module.exports = __webpack_public_path__ + "img/gushuo-1.6f639be5.jpg";